import { call, put, takeEvery} from 'redux-saga/effects';
import { getNft } from '../../services/nft-services';
import { GET_NFT } from './actionTypes';
import { nftApiError, getNFTSuccess } from "./action"


function* getNftSaga({ }) {
    try {
      const response = yield call(getNft)
      // console.log(response);
      yield put(getNFTSuccess(response))
    } catch (error) {
      console.log(error);
      yield put(nftApiError(error))
    }
}

function* nftSaga() {
    yield takeEvery(GET_NFT, getNftSaga)
}

export default nftSaga